import type { ContrastGrade } from "@/color/contrast";
import { cn } from "@/ui/kit/cn";

export function GradeBadge({ grade, label }: { grade: ContrastGrade; label?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded px-1.5 py-px font-medium text-[10px]",
        grade === "pass" && "bg-ok/15 text-ok",
        grade === "close" && "bg-warn/15 text-warn",
        grade === "fail" && "bg-danger/15 text-danger",
      )}
    >
      {grade === "pass" ? "pass" : grade === "close" ? "close" : "fail"}
      {label && <span className="font-normal opacity-80">{label}</span>}
    </span>
  );
}

/** Small dot used in lists: green/amber/red. */
export function GradeDot({ grade }: { grade: ContrastGrade }) {
  return (
    <span
      title={`contrast: ${grade}`}
      className={cn(
        "inline-block size-1.5 shrink-0 rounded-full",
        grade === "pass" && "bg-ok/70",
        grade === "close" && "bg-warn",
        grade === "fail" && "bg-danger",
      )}
    />
  );
}
